/* eslint-disable camelcase */
import { all, takeEvery, put, call } from "redux-saga/effects";
import { fetchProgramsList } from "../../../services/programs/services";
import { types } from "./actions";
import { types as commonTypes } from "../../common/actions";

export function* FETCH_SERVICES_LIST({ payload }) {
  // console.log(Date.now());
  if (!payload.bIsIterate)
    yield put({
      type: commonTypes.SET_STATE,
      payload: {
        loading: true
      }
    });

  const response = yield call(fetchProgramsList);

  if (response) {
    if (response.status === "success") {
      yield put({
        type: types.SET_STATE,
        payload: {
          serviceList: response.data
        }
      });
    } else {
      yield put({
        type: commonTypes.SET_STATE,
        payload: {
          isError: true,
          errContent: response.message.message
        }
      });
    }
  }

  if (!payload.bIsIterate)
    yield put({
      type: commonTypes.SET_STATE,
      payload: {
        loading: false
      }
    });
}

export function* RESET_SERVICES_LIST() {
  yield put({
    type: types.SET_STATE,
    payload: {
      serviceList: {}
    }
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(types.FETCH_SERVICES_LIST, FETCH_SERVICES_LIST),
    takeEvery(types.RESET_SERVICES_LIST, RESET_SERVICES_LIST),
    null
  ]);
}
